import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { DateCalendar as MuiDateCalendar } from '@mui/x-date-pickers/DateCalendar';
import cn from 'classnames';
import { format as formatDate } from 'date-fns';
import { TextButton } from '../TextButton';
import { CalendarHeader } from './CalendarHeader';
import styles from './DatePicker.module.scss';
import { GetDateCalendarTID } from './DatePicker.utils';
import { DayCell } from './DayCell';
export function DateCalendar(props) {
    const { value, onChange, minDate, maxDate, shouldDisableDate, getDayMeta, actions, className, style, testId } = props;
    const { DateCalendarTestIds } = useMemo(()=>GetDateCalendarTID(testId), [
        testId
    ]);
    const handleChange = (date)=>{
        if (date == null || isNaN(date.getTime())) {
            onChange(null);
            return;
        }
        // Clone before normalising — date.setHours mutates in-place and leaks the zeroed time to callers.
        const normalized = new Date(date);
        normalized.setHours(0, 0, 0, 0);
        onChange(normalized);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.calendarRoot, className),
        style: style,
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx(MuiDateCalendar, {
                value: value,
                onChange: handleChange,
                minDate: minDate,
                maxDate: maxDate,
                shouldDisableDate: shouldDisableDate,
                views: [
                    'day'
                ],
                reduceAnimations: true,
                dayOfWeekFormatter: (date)=>formatDate(date, 'EEE'),
                slots: {
                    day: DayCell,
                    calendarHeader: CalendarHeader
                },
                slotProps: {
                    // TODO: replace `as any` once MUI v7 typed-slot augmentation is available.
                    day: {
                        getDayMeta,
                        testIdRoot: testId
                    },
                    calendarHeader: {
                        testIdRoot: testId
                    }
                }
            }),
            actions != null && actions.length > 0 && /*#__PURE__*/ _jsx("div", {
                className: styles.actions,
                children: actions.map((action, idx)=>{
                    var _action_testId;
                    return /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({
                        skin: "primary",
                        underline: "none",
                        testId: (_action_testId = action.testId) !== null && _action_testId !== void 0 ? _action_testId : testId ? DateCalendarTestIds.Action(testId, idx) : undefined,
                        onClick: action.onClick
                    }, action.noBi ? {
                        noBi: action.noBi
                    } : {
                        bi: action.bi
                    }), {
                        children: action.label
                    }), action.label);
                })
            })
        ]
    });
}
